import { E2FAMethod, E2FATab } from 'src/types'
import { Totp2FAInner } from './totp-two-fa.component'

interface IProps {
  method: E2FAMethod | null
  tab: E2FATab
}

export const Totp2FA = (props: IProps) => {
  if (props.tab !== E2FATab.Totp) {
    return null
  }

  return <Totp2FAInner method={props.method} />
}
